export enum ReviewCodeEnum {
    TOO_BAD = 'TOO_BAD',
    BAD = 'BAD',
    NEUTRAL = 'NEUTRAL',
    GOOD = 'GOOD',
    LOVE = 'LOVE'
}
